export default __webpack_public_path__ + "static/media/about-work-contact.fd007b98.png";